import versions from "../../versions.json";

export function checkPasswordStrength(password: string): string | null {
  if (password.length < 8) {
    return "Password must be at least 8 characters long.";
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must include at least one uppercase letter.";
  }
  if (!/[a-z]/.test(password)) {
    return "Password must include at least one lowercase letter.";
  }
  if (!/[0-9]/.test(password)) {
    return "Password must include at least one digit.";
  }
  if (!/[!@#$%^&*]/.test(password)) {
    return "Password must include at least one special character (!@#$%^&*).";
  }
  return null;
}

export const frontVersionInfo = {
  service_name:   versions.service,
  version_number: versions.currentVersion,
  release_date:   versions.versions[versions.versions.length - 1]?.releaseDate,
  features:       versions.versions[versions.versions.length - 1]?.features,
  history:        versions.versions
};